export const RESTAURANTS_PAGE = '/';
export const SEARCH_PAGE = '/search';
export const PROFILE_PAGE = '/profile';
